import axios from 'axios';
import React, { useState, useEffect } from 'react';

import SelectComponent from '../common/select';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_placket_front'
});

const productId = document.getElementById('mtm-customize').dataset.productId;

const MtmPlackets = ({ setPlacketData }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const getList = async () => {
      const response = await client.get('?product_id=' + productId);
      setList(response.data.result);
    };
    getList();
  }, []);

  if (!list) return 'No plackets!';

  return (
    <div className="mtm-item__wrapper" id="mtm-plackets">
      <h3 className="mtm-item__title">PLACKETS</h3>
      <div className="mtm-item__selects row row-cols-2 row-cols-md-4">
        {list.map((item, ind) => (
          <SelectComponent
            setOptionData={setPlacketData}
            isSetAttributes
            item={item}
            ind={ind}
            name="plackets"
            key={`${item.value}-${ind}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MtmPlackets;
